import React, { useState, useEffect, useCallback } from "react";
import _flattern from "lodash/flatten";
import {
  Table,
  TableHeader,
  TableBody,
  TableVariant,
} from "@patternfly/react-table";

export default (props) => {
  const data = props.data;

  const headers = [{ title: "Product Name" }, { title: "Select Count" }];

  // data is an array of array, like
  // [["Red Hat Enterprise Linux", 51], ["OpenShift Container Platform 4", 2]]
  const dataRows = data.map((e) => ({
    cells: [e[0], e[1]],
  }));

  const [rows, setRows] = useState(dataRows);

  const renderRows = useCallback(() => {
    let renderedRows = [];
    props.data.forEach((e, index) => {
      renderedRows.push(dataToRow(e));
    });

    return _flattern(renderedRows);
  }, [props]);

  useEffect(() => {
    // if props.activities changed, re-build the rows
    setRows(renderRows);
  }, [props, renderRows]);

  function dataToRow(e) {
    return [
      {
        cells: [e[0], e[1]],
      },
    ];
  }

  return (
    <>
      <Table
        aria-label="usage-table"
        variant={TableVariant.compact}
        cells={headers}
        rows={rows}
      >
        <TableHeader />
        <TableBody />
      </Table>
    </>
  );
};
